module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAUklEQVQoFZXBsQ3AMAzAMOn/o10NHjoZCCmP5JE8kjXhYIisCQdDZE2I4SBrQgwHWRMOhsiacDBE1oQYfibEEFkTYviZEENkTTgYImvCwRB59AEGMTAPm8KKGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_06.png
// module id = 228
// module chunks = 0